import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getLabel } from '../helpers';
import { selectListsDetailPage } from 'app/containers/ListsPage/containers/ListsDetailPage/selectors';

export const useValues = () => {
	const { contactFilters } = useSelector(selectListsDetailPage);
	const values = useMemo(
		() =>
			contactFilters?.contactLocation?.map(({ city, longState, searchValue, state }) => {
				const label = getLabel({ city, longState, searchValue, state });
				return { label, value: searchValue };
			}) ?? [],
		[contactFilters]
	);

	return values;
};
